import { Navigate } from "react-router-dom";
import Centres from "../pages/Centres";
import Formations from "../pages/Formations";
import Course from "../pages/Course";
import ProtectedRoute from "../components/Common/ProtectedRoute";
import LearnerReporting from "../pages/Cfp/reporting/Learner";
import CustomerReporting from "../pages/Cfp/reporting/CustomerReporting";
import CourseReporting from "../pages/Cfp/reporting/ProjectReporting";
import RevenueByProject from "../pages/Cfp/reporting/revenue/RevenueByProject";
import RevenueByCourse from "../pages/Cfp/reporting/revenue/RevenueByCourse";
import RevenueByClient from "../pages/Cfp/reporting/revenue/RevenueByClient";
import RevenueByMonth from "../pages/Cfp/reporting/revenue/RevenueByMonth";
import RevenueByFolder from "../pages/Cfp/reporting/revenue/RevenueByFolder";
import RevenueByReference from "../pages/Cfp/reporting/revenue/RevenueByReference";
import RevenueByCity from "../pages/Cfp/reporting/revenue/RevenueByCity";
import FolderDetail from "../pages/Cfp/folder/detail";
import Reporting from "../pages/Cfp/reporting/index";
import TrainerList from "../pages/Cfp/trainers/index";
import { FolderLayout } from "../layouts/cfp/folder-layout";
import { ReportingLayout } from "../layouts/cfp/reporting-layout";
import Refresh from "../pages/Apprenants/Refresh/Refresh";
import LearnerLayout from "../layouts/cfp/learner-layout";
import { SearchProviderProject } from "../contexts/cfp/SearchContextProject";
import DashboardCfp from "../pages/Cfp/analytic/DashboardCfp";
import DashboardLayout from "../layouts/cfp/dashboard-layout";
import { DashboardCfpProvider } from "../contexts/cfp/DashboardCfpProvider";
import Objectives from "../pages/Cfp/analytic/Objective";
import Trainer from "../pages/Cfp/analytic/Trainer";
import CfpReservation from "../pages/Cfp/reservation/index";
import ReservationLayout from "../layouts/cfp/reservation-layout";
import Evaluation from "../pages/Cfp/evaluation/index";
import EvaluationFroid from "../pages/Cfp/evaluation/EvaluationFroid";
import Notice from "../pages/Cfp/evaluation/notice";
import LeanerList from "../pages/Cfp/learner/index";
import Project from "../pages/Cfp/project/index";
import SubcontractorList from "../pages/Cfp/subcontractor/index";
import Place from "../pages/Cfp/place/index";
import { FolderCfp } from "../pages/Cfp/photo/folder-cfp";
import { ProjetCfp } from "../pages/Cfp/photo/project-cfp";
import { CrudImageCfp } from "../pages/Cfp/photo/crud-image-cfp";
import { NewInvoice } from "../pages/Cfp/invoice/Formulaire/new-invoice";
import { VoirDetails } from "../pages/Cfp/invoice/Details/voir-details";
import { EditInvoice } from "../pages/Cfp/invoice/Formulaire/edit-invoice";
import DetailModule from "../pages/Cfp/catalogue/DetailModule";
import ProjectDetail from "../pages/Cfp/project/detail";
import { GererCompte } from "../pages/Cfp/invoice/Compte/gestion-compte";
import { Proforma } from "../pages/Cfp/invoice/Proforma/Liste/proforma-list";
import { NewProforma } from "../pages/Cfp/invoice/Proforma/formulaire/new-proforma";
import { EditProforma } from "../pages/Cfp/invoice/Proforma/formulaire/edit-proforma";
import CustomerList from "../pages/Cfp/customer/index";
import ProformaLayout from "../layouts/proforma-layout";
import { Draft } from "../pages/Cfp/invoice/Proforma/Liste/draft-all";
import { ConvertiAll } from "../pages/Cfp/invoice/Proforma/Liste/converti-all";
import CustomerLayout from "../layouts/cfp/customer-layout";
import HomePage from "../pages/Cfp/home/index";
import QcmIndexCfp from "../pages/Cfp/Testing/QcmIndexCfp";
import EditQcmCfp from "../pages/Cfp/Testing/qcm-edit-cfp";
import DetailsQcmCfp from "../pages/Cfp/Testing/show-details-cfp";
import ResultQcmCpf from "../pages/Cfp/Testing/result-qcm-cfp";
import RapportCfp from "../pages/Cfp/Testing/rapport-cfp";
import BaremeCfp from "../pages/Cfp/Testing/bareme-cfp";
import EvaluationCfp from "../pages/Cfp/Testing/evaluation-cfp";
import CreateQcmCfp from "../pages/Cfp/Testing/qcm-create-cfp";
import LayoutSkillCfp from "../layouts/layout-skill";
import ProjectListSkill from "../pages/Cfp/skill_matrix/ProjectListSkill";
import Skills from "../pages/Cfp/skill_matrix/Skills";
import ManageSkill from "../pages/Cfp/skill_matrix/ManageSkill";
import FormateurCalendar from "../pages/Cfp/agenda/formateurs/FormateurCalendar";
import SemaineNewCalendar from "../pages/Cfp/agenda/semaines/SemaineNewCalendar";
import Catalogue from "../pages/Cfp/catalogue/catalogue";
import CatalogLayout from "../layouts/cfp/catalog-layout";
import PreparationCatalog from "../pages/Cfp/catalogue/Preparation";
import CorbeilleCatalog from "../pages/Cfp/catalogue/Corbeille";
import { Attendance } from "../pages/Cfp/attendance";
import Attribut from "../pages/Cfp/badge/Attribut";
import CreateBadge from "../pages/Cfp/badge/Create";
import Badge from "../pages/Cfp/badge/Badge";
import { ListeFacture } from "../pages/Cfp/invoice/liste-facture";
import InvoiceLayout from "../layouts/invoice-layout";
import { TableauDeBord } from "../pages/Cfp/invoice/tableau-de-bord";
import LayoutCalendarCfp from "../layouts/cfp/agenda-layout";
import AnnuelCalendar from "../pages/Cfp/agenda/annuels/AnnuelCalendar";
import FolderList from "../pages/Cfp/folder/index";
import CfpLayout from "../layouts/cfp-layout";
import { SearchCatalogProvider } from "../contexts/SearchCatalogContext";
import { ContextProvider } from "../contexts/ContextcatalogProvider";
import { PhotoContent } from "../contents/photoContent";
import { HomeContentAttendance } from "../contents/home-content";
import { AuthCalendarProvider } from "../contexts/AuthCalendarProvider";
import { TestingContent } from "../contents/testing-content";
import { ReferentContent } from "../contents/referent-content";
import ListReferentCfp from "../pages/Cfp/referent/liste-referent-cfp";
import LoyaltyRewardsLayout from "../layouts/cfp/loyalty_rewards-layout";
import RewardsList from "../pages/Cfp/loyalty/RewardsList";
import RewardsForm from "../pages/Cfp/loyalty/RewardsForm";
import ParticulierLayout from "../layouts/cfp/particulier-layout";
import ParticuliersList from "../pages/Cfp/particulier/ParticuliersList";
import { ModuleProvider } from "../contexts/ModuleContext";
import RefreshLayout from "../layouts/refresh-layout";
import Module from "../pages/Cfp/refresh/Module";
import Create from "../pages/Cfp/refresh/Create";
import { elements } from "chart.js";
import Liste from "../pages/Cfp/refresh/Liste";
import CampaignListCfp from "../pages/Cfp/Testing/Campaign/campaign-list-cfp";
import CreateInvitationCfp from "../pages/Cfp/Testing/Campaign/create-invitation-cfp";
import InvitationListCfp from "../pages/Cfp/Testing/invitations/invitation-list-cfp";
import InvitationDetailsCfp from "../pages/Cfp/Testing/invitations/invitations-details-cfp";
import CreateCampaignCfp from "../pages/Cfp/Testing/Campaign/create-campaign-cfp";
import CampaignStepOneCfp from "../pages/Cfp/Testing/Campaign/create-step-one";
import CampaignStepOne from "../pages/Cfp/Testing/Campaign/create-step-one";
import LieuetSalleLayout from "../layouts/cfp/lieu-et-salle-layout";
import CampaignStepTwoCfp from "../pages/Cfp/Testing/Campaign/create-step-two-cfp";
import CampaignStepThreeCfp from "../pages/Cfp/Testing/Campaign/create-step-three";
import CampaignStepFourCfp from "../pages/Cfp/Testing/Campaign/create-step-four";
import GlobalResultsCfp from "../pages/Cfp/Testing/global-results-cfp";
import DetailsResultsCfp from "../pages/Cfp/Testing/details-results-cfp";
import CatalogueOnlineActive from "../pages/Cfp/catalogue_public/is_active";
import CatalogueInPreparationOnline from "../pages/Cfp/catalogue_public/Preparation";
import CatalogueInDeleteOnline from "../pages/Cfp/catalogue_public/Corbeille";
import CatalogOnlineLayout from "../layouts/cfp/cataloque_online_layout";
import EvaluationsFroids from "../pages/Cfp/evaluationFroid";
import ProfilCfp from "../pages/Cfp/Profil";
import ChangePassword from "../pages/Cfp/passeword";
import LayoutSkill from "../layouts/layout-skill";
import { ProjectFinished } from "../pages/Cfp/project/finished";
import { ProjectPlanned } from "../pages/Cfp/project/planned";
import { ProjectCanceled } from "../pages/Cfp/project/canceled";
import { ProjectFenced } from "../pages/Cfp/project/fenced";
import { ProjectInProgress } from "../pages/Cfp/project/in-progress";
import { CaLayout } from "../layouts/cfp/ca-layout";
import { ListeBonCommande } from "../pages/Cfp/bon_commande";
import { ProjectDeferred } from "../pages/Cfp/project/deferred";
import { ProjectInPreparation } from "../pages/Cfp/project/in-preparation";
import { ProjectDleted } from "../pages/Cfp/project/Deleted";
import { Recovery } from "../pages/Cfp/recovery/index";
import LayoutDispForm from "../pages/Cfp/agenda/dispoFormateur/LayoutDispForm";
import MaterialsManagement from "../pages/Cfp/materials";
import FmfpLayout from "../layouts/cfp/fmfp-layout";
import FmfpIndex from "../pages/Cfp/Fmfp";
import DetailsFmfp from "../pages/Cfp/Fmfp/details-fmfp";
import AideFmfp from "../pages/Cfp/Fmfp/aide-fmfp";
import HotEvaluationByProject from "../pages/Cfp/evaluation/evaluation_by_project";
import BonCommandeView from "../pages/Cfp/bon_commande/pages/BonCommandeView";
import NewProject from "../pages/Cfp/project/new-project";
import LayoutDispoMateriel from "../pages/Cfp/agenda/dispoMateriel/LayoutDispoMateriel";
import FormateurAncien from "../pages/Cfp/trainers/FormateurAncien";
import { NewAcompte } from "../pages/Cfp/invoice/Acompte/new-acompte";
import { Acompte } from "../pages/Cfp/invoice/Acompte/Liste/acompte-list";
import { EditAcompte } from "../pages/Cfp/invoice/Acompte/formulaire/edit-acompte";
import NewFmfp from "../pages/Cfp/Fmfp/new-fmfp";
import Accueil from "../pages/Cfp/Documentation/Accueil";
import DocCatalogue from "../pages/Cfp/Documentation/Catalogue/DocCatalogue";
import { path } from "framer-motion/client";
import DocProjet from "../pages/Cfp/Documentation/Projet/DocProjet";
import DocDevis from "../pages/Cfp/Documentation/Devis/DocDevis";
import DocumentLayouts from "../layouts/cfp/layouts-documents";
import DocCatalogueAjout from "../pages/Cfp/Documentation/Catalogue/DocCatalogueAjout";
import DocCatalogueDetail from "../pages/Cfp/Documentation/Catalogue/DocCatalogueDetail";
import EmargementCfp from "../pages/Cfp/attendance/emargement";
import DocCreationIntra from "../pages/Cfp/Documentation/Projet/DocCreationIntra";
import DocCreationInter from "../pages/Cfp/Documentation/Projet/DocCreationInter";
import DocStatus from "../pages/Cfp/Documentation/Projet/DocStatus";
import DocDetails from "../pages/Cfp/Documentation/Projet/DocDetails";
import PorteFeuilleClientDashboard from "../pages/Cfp/analyse_portefeuille/PorteFeuilleClientDashboard";
import DocDevisAjout from "../pages/Cfp/Documentation/Devis/DocDevisAjout";
import DocDevisStatut from "../pages/Cfp/Documentation/Devis/DocDevisStatut";
import DocPlace from "../pages/Cfp/Documentation/Lieu_et_Salle/DocPlace";
import DocPlaceAdd from "../pages/Cfp/Documentation/Lieu_et_Salle/DocPlaceAdd";
import DocPlace_Salle_Contact from "../pages/Cfp/Documentation/Lieu_et_Salle/DocPlace_Salle_Contact";
import CatalogueEnLigne from "../pages/Cfp/Documentation/Catalogue_en_ligne/catalogue_en_ligen";
import CatalogueEnLigneDetail from "../pages/Cfp/Documentation/Catalogue_en_ligne/catalogue_en_ligne_detail";
import DocFacture from "../pages/Cfp/Documentation/Facture/DocFacture";
import DocFactureAdd from "../pages/Cfp/Documentation/Facture/DocFactureAdd";
import { NewSolde } from "../pages/Cfp/invoice/Solde/new-solde";
import { EditSolde } from "../pages/Cfp/invoice/Solde/formulaire/edit-solde";
import DocAnalytics from "../pages/Cfp/Documentation/Analytics/Doc_analytics";
import DocAnalyticsPresentation from "../pages/Cfp/Documentation/Analytics/Doc_analytics_presentation";
import DocAnalyticsObjectif from "../pages/Cfp/Documentation/Analytics/Doc_analytics_objectif";
import Doc_Commande from "../pages/Cfp/Documentation/BDC/Commande";
import Formateur from "../pages/Cfp/Documentation/Formateur/formateur";
import FormateurAdd from "../pages/Cfp/Documentation/Formateur/formateur_add";
import Espace from "../pages/Cfp/marketplace/Espace";
import Profile from "../pages/Cfp/marketplace/profile";
import Regulation from "../pages/Cfp/marketplace/regulation";
import Gestion_Formateur from "../pages/Cfp/Documentation/Formateur/Gestion_Formateur";
import CommandePresentation from "../pages/Cfp/Documentation/BDC/commandePresentation";
import CommandeAdd from "../pages/Cfp/Documentation/BDC/commande_add";
import Apprenants from "../pages/Cfp/Documentation/Apprenants/apprenants";
import ApprenantsAdd from "../pages/Cfp/Documentation/Apprenants/apprenantsAdd";
import ApprenantsGestion from "../pages/Cfp/Documentation/Apprenants/apprenantGestion";
import Clients from "../pages/Cfp/Documentation/Clients/clients";
import ClientsAdd from "../pages/Cfp/Documentation/Clients/clientsAdd";
import ClientsGestion from "../pages/Cfp/Documentation/Clients/clientsGestion";
import Particulier from "../pages/Cfp/Documentation/Particulier/particulier";
import ParticulierAdd from "../pages/Cfp/Documentation/Particulier/particulierAdd";
import ParticulierGestion from "../pages/Cfp/Documentation/Particulier/particulierGestion";
import Admin from "../pages/Cfp/Documentation/Admin/admin";
import AdminAdd from "../pages/Cfp/Documentation/Admin/adminAdd";
import AdminGestion from "../pages/Cfp/Documentation/Admin/adminGestion";
import SousTraitant from "../pages/Cfp/Documentation/SousTraitant/soustraitant";
import SousTraitantAdd from "../pages/Cfp/Documentation/SousTraitant/soustraitantAdd";
import Qualiopi from "../pages/Cfp/qualiopi";
const INVOICE_TYPES = {
  ALL: 1,
  UNPAID: 2,
  OVERDUE: 3,
  DRAFTS: 4,
  SAINE: 5,
  PERDU: 6,
  douteuse: 11,
  en_litige: 12,
  irrecouvrable: 13,
  transmis_huissier: 14,
  poursuite_judiciaire: 15,
};

const cfpRoutes = {
  path: "/cfp",
  element: (
    <ProtectedRoute allowedUserTypes={["superAdminCfp", "adminCfp"]}>
      <CfpLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <HomePage />,
    },
    {
      path: "profile",
      element: <ProfilCfp />,
    },
    {
      path: "lieu_salle",
      element: <LieuetSalleLayout />,
      children: [{ index: true, element: <Place /> }],
    },
    {
      path: "reporting",
      element: <ReportingLayout />,
      children: [
        { index: true, element: <Reporting /> },
        { path: "apprenant", element: <LearnerReporting /> },
        { path: "client", element: <CustomerReporting /> },
        { path: "cours", element: <CourseReporting /> },
      ],
    },
    {
      path: "ca",
      element: <CaLayout />,
      children: [
        { index: true, element: <Navigate to="ca_projet" /> },
        { path: "ca_projet", element: <RevenueByProject /> },
        { path: "ca_cours", element: <RevenueByCourse /> },
        { path: "ca_client", element: <RevenueByClient /> },
        { path: "ca_mois", element: <RevenueByMonth /> },
        { path: "ca_dossier", element: <RevenueByFolder /> },
        { path: "ca_reference", element: <RevenueByReference /> },
        { path: "ca_ville", element: <RevenueByCity /> },
      ],
    },
    {
      path: "fmfp",
      element: <FmfpLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="en_soumission" />,
        },
        {
          path: "nouveau",
          element: <NewFmfp />,
        },
        {
          path: "en_soumission",
          element: <FmfpIndex status_name="En soumission" />,
        },
        {
          path: "en_execution",
          element: <FmfpIndex status_name="Exécuté" />,
        },
        {
          path: "service_fait",
          element: <FmfpIndex status_name="Service fait" />,
        },
        {
          path: "cloture",
          element: <FmfpIndex status_name="Cloturé" />,
        },
        {
          path: "refuse",
          element: <FmfpIndex status_name="Refusé" />,
        },
        {
          path: "aide",
          element: <AideFmfp />,
        },
        { path: "details/:id", element: <DetailsFmfp /> },
      ],
    },
    {
      path: "refresh",
      element: (
        <ModuleProvider>
          {" "}
          <RefreshLayout />{" "}
        </ModuleProvider>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="module" />,
        },
        {
          path: "module",
          element: <Module />,
        },
        {
          path: "creer",
          element: <Create />,
        },
        {
          path: "liste",
          element: <Liste />,
        },
      ],
    },
    {
      path: "skill_matrix",
      element: <LayoutSkill />,
      children: [
        {
          index: true,
          element: <Navigate to="projets" />,
        },
        {
          path: "projets",
          element: <ProjectListSkill />,
        },
        {
          path: "projets/:idProjet",
          element: <Skills />,
        },
        {
          path: "gestion-skill",
          element: <ManageSkill />,
        },
      ],
    },
    {
      path: "loyalty_rewards",
      element: <LoyaltyRewardsLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: "list",
          element: <RewardsList />,
        },
        {
          path: "create",
          element: <RewardsForm />,
        },
      ],
    },
    {
      path: "particulier",
      element: <ParticulierLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: "list",
          element: <ParticuliersList />,
        },
      ],
    },
    {
      path: "client",
      element: <CustomerLayout />,
      children: [
        {
          index: true,
          element: <CustomerList />,
        },
      ],
    },
    { path: "centre", element: <Centres /> },
    { path: "annuaire", element: <Formations /> },
    { path: "formateur", element: <TrainerList /> },
    { path: "formateur/ancien", element: <FormateurAncien /> },
    { path: "sous_traitant", element: <SubcontractorList /> },
    { path: "projet/en_cours", element: <ProjectInProgress /> },
    { path: "projet/preparation", element: <ProjectInPreparation /> },
    { path: "projet/termine", element: <ProjectFinished /> },
    { path: "projet/reporte", element: <ProjectDeferred /> },
    { path: "projet/planifie", element: <ProjectPlanned /> },
    { path: "projet/annule", element: <ProjectCanceled /> },
    { path: "projet/cloture", element: <ProjectFenced /> },
    { path: "projet/corbeille", element: <ProjectDleted /> },
    { path: "projet/detail/:id", element: <ProjectDetail /> },
    { path: "nouveau_projet", element: <NewProject /> },
    {
      path: "apprenant",
      element: <LearnerLayout />,
      children: [
        {
          index: true,
          element: <LeanerList />,
        },
      ],
    },
    {
      path: "evaluation_a_chaud",
      element: <Evaluation />,
    },
    {
      path: "evaluation_a_chaud/detail/:projectId",
      element: <HotEvaluationByProject />,
    },
    {
      path: "evaluation/froids",
      element: <EvaluationsFroids />,
    },
    {
      path: "evaluation/avis",
      element: <Notice />,
    },
    {
      path: "reservation",
      element: <ReservationLayout />,
      children: [{ index: true, element: <CfpReservation /> }],
    },
    {
      path: "analytic",
      element: (
        <DashboardCfpProvider>
          <DashboardLayout />
        </DashboardCfpProvider>
      ),
      children: [
        {
          index: true,
          element: <DashboardCfp />,
        },
        {
          path: "objectif",
          element: <Objectives />,
        },
        {
          path: "formateur",
          element: <Trainer />,
        },
      ],
    },
    {
      path: "dossier",
      element: <FolderLayout />,
      children: [
        { index: true, element: <FolderList /> },
        { path: "detail/:idDossier", element: <FolderDetail /> },
      ],
    },
    {
      path: "materiel",
      children: [{ index: true, element: <MaterialsManagement /> }],
    },
    {
      path: "presence",
      element: <HomeContentAttendance />,
      children: [
        { index: true, element: <Attendance /> },
        { path: "emargement/:id", element: <EmargementCfp /> },
      ],
    },
    {
      path: "catalogue",
      element: (
        <ContextProvider>
          <SearchCatalogProvider>
            <CatalogLayout />
          </SearchCatalogProvider>
        </ContextProvider>
      ),
      children: [
        { index: true, element: <Catalogue /> },
        { path: "preparation", element: <PreparationCatalog /> },
        { path: "corbeille", element: <CorbeilleCatalog /> },
        { path: ":id/edit", element: <DetailModule /> },
      ],
    },
    {
      path: "cours_en_ligne",
      element: <CatalogOnlineLayout />,
      children: [
        { index: true, element: <CatalogueOnlineActive /> },
        { path: "preparation", element: <CatalogueInPreparationOnline /> },
        { path: "corbeille", element: <CatalogueInDeleteOnline /> },
        { path: ":id/edit", element: <DetailModule /> },
      ],
    },
    { path: "cours", element: <Course /> },
    {
      path: "agenda",
      element: <AuthCalendarProvider />,
      children: [
        {
          element: <LayoutCalendarCfp />,
          children: [
            { index: true, element: <AnnuelCalendar /> },
            { path: "annuel", element: <AnnuelCalendar /> },
            { path: "formateur", element: <FormateurCalendar /> },
            { path: "semaine", element: <SemaineNewCalendar /> },
          ],
        },
      ],
    },
    {
      path: "disponibilite_de_formateur",
      element: <LayoutDispForm />,
    },
    {
      path: "disponibilite_de_materiel",
      element: <LayoutDispoMateriel />,
    },
    {
      path: "analyse_portefeullie_client",
      element: <PorteFeuilleClientDashboard />,
    },
    {
      path: "facture",
      element: <InvoiceLayout />,
      children: [
        {
          index: true,
          element: <ListeFacture idInvoice={INVOICE_TYPES.ALL} />,
        },
        { path: "tableau-de-bord", element: <TableauDeBord /> },
        {
          path: "non-paye",
          element: <ListeFacture idInvoice={INVOICE_TYPES.UNPAID} />,
        },
        {
          path: "echue",
          element: <ListeFacture idInvoice={INVOICE_TYPES.OVERDUE} />,
        },
        {
          path: "brouillons",
          element: <ListeFacture idInvoice={INVOICE_TYPES.DRAFTS} />,
        },
        {
          path: "saine",
          element: <ListeFacture idInvoice={INVOICE_TYPES.SAINE} />,
        },
        {
          path: "perdu",
          element: <ListeFacture idInvoice={INVOICE_TYPES.PERDU} />,
        },
        {
          path: "douteuse",
          element: <ListeFacture idInvoice={INVOICE_TYPES.douteuse} />,
        },
        {
          path: "en_litige",
          element: <ListeFacture idInvoice={INVOICE_TYPES.en_litige} />,
        },
        {
          path: "irrecouvrable",
          element: <ListeFacture idInvoice={INVOICE_TYPES.irrecouvrable} />,
        },
        {
          path: "transmis_huissier",
          element: <ListeFacture idInvoice={INVOICE_TYPES.transmis_huissier} />,
        },
        {
          path: "poursuite_judiciaire",
          element: (
            <ListeFacture idInvoice={INVOICE_TYPES.poursuite_judiciaire} />
          ),
        },
        {
          path: "nouveau-facture",
          element: <NewInvoice />,
        },
        {
          path: "details/:id",
          element: <VoirDetails />,
        },
        {
          path: "modifie-facture/:id",
          element: <EditInvoice />,
        },
        {
          path: "compte",
          element: <GererCompte />,
        },
        {
          path: "nouveau-facture-acompte",
          element: <NewAcompte />,
        },
        {
          path: "facture-acompte",
          element: <Acompte />,
        },
        {
          path: "modifie-acompte/:id",
          element: <EditAcompte />,
        },
        {
          path: "nouveau-facture-solde",
          element: <NewSolde />,
        },
        {
          path: "modifie-solde/:id",
          element: <EditSolde />,
        },
      ],
    },
    {
      path: "utilisateurs",
      element: <ReferentContent />,
      children: [
        {
          index: true,
          element: <ListReferentCfp />,
        },
      ],
    },
    {
      path: "proforma",
      element: <ProformaLayout />,
      children: [
        {
          index: true,
          element: <Proforma />,
        },
        {
          path: "details/:id",
          element: <VoirDetails />,
        },
        {
          path: "brouillons",
          element: <Draft />,
        },
        {
          path: "converti",
          element: <ConvertiAll />,
        },

        {
          path: "nouveau-proforma",
          element: <NewProforma />,
        },
        {
          path: "modifie-proforma/:id",
          element: <EditProforma />,
        },
      ],
    },
    { path: "badge", element: <Badge /> },
    { path: "badge/attribut", element: <Attribut /> },
    { path: "badge/creer", element: <CreateBadge /> },
    {
      path: "photos",
      element: <PhotoContent />,
      children: [
        {
          index: true,
          element: <FolderCfp />,
        },
        {
          path: "projets",
          element: <ProjetCfp />,
        },
        {
          path: "ajout",
          element: <CrudImageCfp />,
        },
      ],
    },
    {
      path: "mot_de_passe",
      element: <ChangePassword />,
    },
    {
      path: "prequal",
      element: <TestingContent />,
      children: [
        {
          index: true,
          element: <QcmIndexCfp />,
        },
        {
          path: "qcm/:id/edit",
          element: <EditQcmCfp />,
        },
        {
          path: "qcm/show/:id",
          element: <DetailsQcmCfp />,
        },
        {
          path: "qcm/:id/list-apprenants/results",
          element: <ResultQcmCpf />,
        },
        {
          path: "qcm/:id/apprenant/:idApprenant/session/:idSession/rapport",
          element: <RapportCfp />,
        },
        {
          path: "qcm/bareme/create/:id",
          element: <BaremeCfp />,
        },
        {
          path: "qcm/:id/category-evaluations",
          element: <EvaluationCfp />,
        },
        {
          path: "qcm/create",
          element: <CreateQcmCfp />,
        },
        {
          path: "qcm/invitation/campaign",
          element: <CampaignListCfp />,
        },
        {
          path: "qcm/invitation/create",
          element: <CreateInvitationCfp />,
        },
        {
          path: "qcm/invitations-index",
          element: <InvitationListCfp />,
        },
        {
          path: "qcm/invitations/:id",
          element: <InvitationDetailsCfp />,
        },
        {
          path: "qcm/campaign/create-1",
          element: <CampaignStepOneCfp />,
        },
        {
          path: "qcm/campaign/create-2",
          element: <CampaignStepTwoCfp />,
        },
        {
          path: "qcm/campaign/create-3",
          element: <CampaignStepThreeCfp />,
        },
        {
          path: "qcm/campaign/create-4",
          element: <CampaignStepFourCfp />,
        },
        {
          path: "global-results",
          element: <GlobalResultsCfp />,
        },
        {
          path: "qcm/:id/appr/:idAppr/session/:idSession/result",
          element: <DetailsResultsCfp />,
        },
      ],
    },
    {
      path: "bon-commande",
      element: <ListeBonCommande />,
    },
    {
      path: "bon-commande/view/:id",
      element: <BonCommandeView />,
    },
    {
      path: "recouvrement",
      element: <Recovery />,
    },
    {
      path: "documentation",
      element: <DocumentLayouts />,
      children: [
        {
          index: true,
          element: <Accueil />,
        },

        {
          path: "doc_catalogue",
          element: <DocCatalogue />,
        },
        {
          path: "doc_catalogue/ajout",
          element: <DocCatalogueAjout />,
        },
        {
          path: "doc_catalogue/detail",
          element: <DocCatalogueDetail />,
        },

        {
          path: "doc_catalogue_en_ligne",
          element: <CatalogueEnLigne />,
        },
        {
          path: "doc_catalogue_en_ligne/detail",
          element: <CatalogueEnLigneDetail />,
        },

        {
          path: "doc_projet",
          element: <DocProjet />,
        },
        {
          path: "doc_projet/creation/intra",
          element: <DocCreationIntra />,
        },
        {
          path: "doc_projet/status",
          element: <DocStatus />,
        },
        {
          path: "doc_projet/detail",
          element: <DocDetails />,
        },
        {
          path: "doc_projet/creation/inter",
          element: <DocCreationInter />,
        },

        {
          path: "doc_devis",
          element: <DocDevis />,
        },
        {
          path: "doc_devis/ajout",
          element: <DocDevisAjout />,
        },
        {
          path: "doc_devis/statut",
          element: <DocDevisStatut />,
        },

        {
          path: "doc_lieu",
          element: <DocPlace />,
        },
        {
          path: "doc_lieu/creation",
          element: <DocPlaceAdd />,
        },
        {
          path: "doc_lieu/gestion",
          element: <DocPlace_Salle_Contact />,
        },

        {
          path: "doc_facture",
          element: <DocFacture />,
        },
        {
          path: "doc_facture/add",
          element: <DocFactureAdd />,
        },

        {
          path: "doc_analytics",
          element: <DocAnalytics />,
        },
        {
          path: "doc_analytics/presentation",
          element: <DocAnalyticsPresentation />,
        },
        {
          path: "doc_analytics/objectif",
          element: <DocAnalyticsObjectif />,
        },

        {
          path: "doc_commande",
          element: <Doc_Commande />,
        },
        {
          path: "doc_commande/presentation",
          element: <CommandePresentation />,
        },
        {
          path: "doc_commande/add",
          element: <CommandeAdd />,
        },

        {
          path: "doc_formateur",
          element: <Formateur />,
        },
        {
          path: "doc_formateur/add",
          element: <FormateurAdd />,
        },
        {
          path: "doc_formateur/gestion",
          element: <Gestion_Formateur />,
        },

        {
          path: "doc_apprenants",
          element: <Apprenants />,
        },
        {
          path: "doc_apprenants/add",
          element: <ApprenantsAdd />,
        },
        {
          path: "doc_apprenants/gestion",
          element: <ApprenantsGestion />,
        },

        {
          path: "doc_clients",
          element: <Clients />,
        },
        {
          path: "doc_clients/add",
          element: <ClientsAdd />,
        },
        {
          path: "doc_clients/gestion",
          element: <ClientsGestion />,
        },

        {
          path: "doc_particulier",
          element: <Particulier />,
        },
        {
          path: "doc_particulier/particulier",
          element: <ParticulierAdd />,
        },
        {
          path: "doc_particulier/gestion",
          element: <ParticulierGestion />,
        },

        {
          path: "doc_admin",
          element: <Admin />,
        },
        {
          path: "doc_admin/admin",
          element: <AdminAdd />,
        },
        {
          path: "doc_admin/gestion",
          element: <AdminGestion />,
        },

        {
          path: "doc_soustraitants",
          element: <SousTraitant />,
        },
        {
          path: "doc_soustraitants/add",
          element: <SousTraitantAdd />,
        },
      ],
    },
    {
      path: "profile-marketplace",
      element: <Espace />,
    },
    {
      path: "espace/profil",
      element: <Profile />,
    },
    {
      path: "espace/reglement",
      element: <Regulation />,
    },
    {
      path: "qualite",
      element: <Qualiopi />,
    },
  ],
};

export default cfpRoutes;
